module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai8-64545d4165e1d348998e817551b97826.jpg";